/* global axios */
import ApiClient from '../ApiClient';

class CopilotUploads extends ApiClient {
    constructor() {
        super('captain/copilot_uploads', { accountScoped: true });
    }

    upload(file) {
        const formData = new FormData();
        formData.append('file', file);
        return axios.post(this.url, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    }
}

export default new CopilotUploads();
